import { createFileRoute } from "@tanstack/react-router";

import { RetellCallsDashboard } from "../tools/dashboards/RetellCallsDashboard";

function RetellCallsRoute() {
  return <RetellCallsDashboard />;
}

export const Route = createFileRoute("/_app/dashboards/retell-calls")({
  component: RetellCallsRoute,
});
